import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Login from "./pages/Login";
import "./App.css";
const App = () => {
  return (
    <div className="app">
      <BrowserRouter>
        <Route path="/" exact component={Login} />
      </BrowserRouter>
    </div>
  );
};

export default App;
